var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _rect2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIgLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.59 15.737c5.045 0 5.051 7.632 0 7.632-5.043 0-5.051-7.632 0-7.632z",
    fill: "url(#ig-live_svg__paint0_linear_5124_96420)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.59 15.737c5.045 0 5.051 7.632 0 7.632-5.043 0-5.051-7.632 0-7.632z",
    fill: "url(#ig-live_svg__paint1_linear_5124_96420)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.405 10.155c-.577.006-1.19.012-1.84.013v-.003c-7.633.008-8.356.153-8.356 9.383 0 9.124.262 9.385 9.382 9.385.46 0 .913.005 1.355.01 4.364.048 7.74.085 7.961-4.768.642-14.106-.401-14.096-8.502-14.02zm3.922 3.286a1.373 1.373 0 112.747 0 1.373 1.373 0 01-2.747 0zm-10.615 6.112a5.878 5.878 0 1111.755 0 5.877 5.877 0 11-11.755 0z",
    fill: "url(#ig-live_svg__paint2_linear_5124_96420)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.405 10.155c-.577.006-1.19.012-1.84.013v-.003c-7.633.008-8.356.153-8.356 9.383 0 9.124.262 9.385 9.382 9.385.46 0 .913.005 1.355.01 4.364.048 7.74.085 7.961-4.768.642-14.106-.401-14.096-8.502-14.02zm3.922 3.286a1.373 1.373 0 112.747 0 1.373 1.373 0 01-2.747 0zm-10.615 6.112a5.878 5.878 0 1111.755 0 5.877 5.877 0 11-11.755 0z",
    fill: "url(#ig-live_svg__paint3_linear_5124_96420)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.066 16.025c-.06-5.503-.084-7.74 1.962-9.866 2.148-2.227 4.494-2.207 12.708-2.139 1.7.014 3.653.03 5.908.03 3.637.006 3.843.036 4.532.136l.04.006c3.15.453 5.542 2.692 5.847 6.576.041.52.041 17.044.001 17.553-.287 3.647-2.385 5.738-4.963 6.404-1.932.5-19.067.5-21 .002-5.325-1.376-5.197-6.594-5.057-12.34.023-.938.046-1.89.046-2.842 0-1.306-.012-2.472-.024-3.52zM18.46 8.099c.373.003.75.006 1.129.006.45 0 .885-.003 1.306-.006 3.657-.025 6.248-.042 8.217 1.927 1.961 1.96 1.947 4.508 1.927 8.285a223.44 223.44 0 00-.002 2.387c.01 2.76.018 4.746-.603 6.353-1.572 4.031-5.565 3.995-9.664 3.958-.394-.004-.788-.008-1.181-.008-.377 0-.753.003-1.126.006-4.239.03-8.158.06-9.718-3.956-.62-1.596-.612-3.97-.603-6.554a269.775 269.775 0 000-2.075c-.01-2.76-.018-4.775.603-6.368 1.563-4.014 5.453-3.986 9.715-3.955z",
    fill: "url(#ig-live_svg__paint4_linear_5124_96420)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.066 16.025c-.06-5.503-.084-7.74 1.962-9.866 2.148-2.227 4.494-2.207 12.708-2.139 1.7.014 3.653.03 5.908.03 3.637.006 3.843.036 4.532.136l.04.006c3.15.453 5.542 2.692 5.847 6.576.041.52.041 17.044.001 17.553-.287 3.647-2.385 5.738-4.963 6.404-1.932.5-19.067.5-21 .002-5.325-1.376-5.197-6.594-5.057-12.34.023-.938.046-1.89.046-2.842 0-1.306-.012-2.472-.024-3.52zM18.46 8.099c.373.003.75.006 1.129.006.45 0 .885-.003 1.306-.006 3.657-.025 6.248-.042 8.217 1.927 1.961 1.96 1.947 4.508 1.927 8.285a223.44 223.44 0 00-.002 2.387c.01 2.76.018 4.746-.603 6.353-1.572 4.031-5.565 3.995-9.664 3.958-.394-.004-.788-.008-1.181-.008-.377 0-.753.003-1.126.006-4.239.03-8.158.06-9.718-3.956-.62-1.596-.612-3.97-.603-6.554a269.775 269.775 0 000-2.075c-.01-2.76-.018-4.775.603-6.368 1.563-4.014 5.453-3.986 9.715-3.955z",
    fill: "url(#ig-live_svg__paint5_linear_5124_96420)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2F54EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.202 30.071l-5.555-3.802c-.256-.176-.515-.269-.73-.269-.415 0-.672.333-.672.891v8.219c0 .557.257.89.671.89.215 0 .47-.093.727-.27l5.557-3.802c.357-.245.555-.575.555-.928 0-.354-.195-.684-.553-.929z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#fff",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig-live_svg__paint0_linear_5124_96420",
    x1: 35.714,
    y1: 4.286,
    x2: 4.286,
    y2: 35.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig-live_svg__paint1_linear_5124_96420",
    x1: 6.088,
    y1: 33.074,
    x2: 34.903,
    y2: 8.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig-live_svg__paint2_linear_5124_96420",
    x1: 35.714,
    y1: 4.286,
    x2: 4.286,
    y2: 35.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig-live_svg__paint3_linear_5124_96420",
    x1: 6.088,
    y1: 33.074,
    x2: 34.903,
    y2: 8.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig-live_svg__paint4_linear_5124_96420",
    x1: 35.714,
    y1: 4.286,
    x2: 4.286,
    y2: 35.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ig-live_svg__paint5_linear_5124_96420",
    x1: 6.088,
    y1: 33.074,
    x2: 34.903,
    y2: 8.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })))));
}

export default __webpack_public_path__ + "./fonts/ig-live.3e01f1875139c15dcee08f2dc4000a12.svg";
export { SvgIgLive as ReactComponent };